/*
 Select-by-segment state (selectedFlightSegments holds full itinerary objects) used to leak into
 results page URLs. Those URLs are saved on brochures/trips and replayed by "Add Options", where a
 multi-segment selection pushes the URL past the host limit (URI_TOO_LONG).
 The state is never read back from the URL, so stripping it is lossless.
*/
const FLIGHT_SELECTION_PARAMS = ['selectedFlightSegments', 'breadCrumbsIndex'];

const RELATIVE_PATH_BASE = 'https://relative-path.invalid';

// qs serializes nested objects as bracketed keys, e.g. selectedFlightSegments[0][flights][0][...]
export const isFlightSelectionParam = (paramName) =>
  FLIGHT_SELECTION_PARAMS.some((param) => paramName === param || paramName.startsWith(`${param}[`));

const removeFlightSelectionParams = (urlString) => {
  if (!urlString) return urlString;

  let url;
  try {
    url = new URL(urlString, RELATIVE_PATH_BASE);
  } catch {
    return urlString;
  }

  const paramsToRemove = [...url.searchParams.keys()].filter(isFlightSelectionParam);
  if (!paramsToRemove.length) {
    return urlString;
  }

  paramsToRemove.forEach((param) => url.searchParams.delete(param));

  const strippedPath = `${url.pathname}${url.search}${url.hash}`;
  const isRelative = url.origin === RELATIVE_PATH_BASE;
  return isRelative ? strippedPath : `${url.origin}${strippedPath}`;
};

export default removeFlightSelectionParams;
